import { http } from '@/core/api/';

const apiUrl = 'api/guidevideo';

export const saveAsync = (data) => {
  return http.post(`${apiUrl}/save`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getGuides = (params, pageIndex, pageSize) =>
  http.get(`${apiUrl}/search`, {
    params: { ...params, pageIndex, pageSize },
  });

export const getGuideVideo = (guideId) => http.get(`${apiUrl}/${guideId}`);
